import React from 'react'
import './opinion.scss';
const Opinion = () => {
    return (
        <>
            <section className='abstract_main' id='howitswork'>
                <img src='\assets\shadow.png' className='shadow'/>
                <div className='innner_abstract'>
                    <div className='custom-container'>
                        <div className='inneer_opinon'>
                            <h2>There are +4,300 affiliates <br></br> <span>waiting to hear about your project</span></h2>
                            {/* <p>Missed out on the private sale? No problem. On our exchange, you’ll find unique tokens that may already be listed but are still waiting to shine. These are the hidden gems of the market, offering early investors a chance to get ahead before they reach their full potential.</p> */}
                            <a href='#booking'>Start here</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Opinion
